import React from 'react';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Modal from '../../Common/Modal';
import styles from './index.module.scss';
import {Commun} from "../../../utils/axios";
import common from "../../../common/common";

class ExchangeRuleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rule: ''
        }
    }

    static defaultProps = {
        visible: false,
        organization: undefined
    };

    static propTypes = {
        visible: PropTypes.bool, // 弹窗是否展示
        organization: PropTypes.number, // 机构Id
    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        const { organization } = this.props;
        if (organization && organization !== prevProps.organization) {
            this.getRule();
        }
    }

    // 获取兑换规则
    getRule = () => {
        this.setState({
            rule: ''
        });

        const { organization } = this.props;
        const searchParam = common.getSearchParam();
        // 高中在线增加入参
        Commun.get(`${common.starApiPrefix}/rule`, {
            organizationId: organization,
            language: common.getLanguage().includes('en') ? 'en' : 'ch',
            appName: searchParam?.appName || ''
        }).then(res => {
            this.setState({
                rule: res || ''
            })
        }).catch(error => {
            console.log(error);
        });
    };

    onCancel = () => {
        typeof this.props.onCancel === 'function' && this.props.onCancel();
    };


    render() {
        const { visible } = this.props;

        const { rule } = this.state;

        return (
            <Modal
                visible={visible}
                width={common.isPhone() ? 30 : 600}
                wrapClassName={styles.ruleModal}
                title={
                    <div className={styles.title}>{intl.get('STAR_EXCHANGE_RULE')}</div>
                }
                closable={true}
                footer={null}
                onCancel={this.onCancel}
            >
                <pre className={styles.ruleBox} dangerouslySetInnerHTML={{__html: rule || ''}}/>
            </Modal>
        )
    }
}
export default ExchangeRuleModal;